export interface RouterProps {}

export const useRouter = (props: RouterProps) => {
  return {
    ...props,
  }
}
